import React, { createContext, useContext, useState, ReactNode } from 'react'

interface ResponsiveTableContextType {
  expandedRows: Set<string>
  toggleRowExpansion: (rowId: string) => void
  isRowExpanded: (rowId: string) => boolean
  collapseAllRows: () => void
}

const ResponsiveTableContext = createContext<ResponsiveTableContextType | null>(null)

interface ResponsiveTableProviderProps {
  children: ReactNode
}

export const ResponsiveTableProvider: React.FC<ResponsiveTableProviderProps> = ({ children }) => {
  const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set())

  const toggleRowExpansion = (rowId: string) => {
    setExpandedRows(prev => {
      const newSet = new Set(prev)
      if (newSet.has(rowId)) {
        newSet.delete(rowId)
      } else {
        newSet.add(rowId)
      }
      return newSet
    })
  }

  const isRowExpanded = (rowId: string) => {
    return expandedRows.has(rowId)
  }

  const collapseAllRows = () => {
    setExpandedRows(new Set())
  }

  const value = {
    expandedRows,
    toggleRowExpansion,
    isRowExpanded,
    collapseAllRows
  }

  return (
    <ResponsiveTableContext.Provider value={value}>
      {children}
    </ResponsiveTableContext.Provider>
  )
}

export const useResponsiveTableContext = (): ResponsiveTableContextType | null => {
  return useContext(ResponsiveTableContext)
}